import { AddressModel, ControlProperty, UliActivityType } from '../../../../../../common';
import { FormArray, FormBuilder } from '@angular/forms';
import { UliContactInformation, UliDriverInformation, UliTruckInformation } from './uli-creation.model';
import { LocalDateModel } from '../../../../../models';

export class MultiStopUliInformation {
  loadNumber: string = null;
  generateLoadNumber = false;
  transportOrders: TransportOrderInformation[] = [];

  constructor(params?: MultiStopUliInformation) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportOrderInformation {
  transportOrderNumber: string = null;
  pickupPartyAddress: AddressModel = null;
  deliveryPartyAddress: AddressModel = null;
  dangerousGoods = false;
  customsGoods = false;
  scheduledDepartureTime: Date = null;
  scheduledArrivalTime: Date = null;
  numberOfHandlingUnits: number = null;
  documentNumbers: string[] = [];
  type = UliActivityType.Outbound;
  weightGross: number = null;
  loadingMeters: number = null;

  constructor(params?: TransportOrderInformation) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface MultiStopUliInformationOutputModel {
  loadNumber: string;
  generateLoadNumber: boolean;
  transportOrders: TransportOrderInformationOutputModel[];
}

export interface TransportOrderInformationOutputModel
  extends Omit<TransportOrderInformation, 'scheduledArrivalTime' | 'scheduledDepartureTime'> {
  scheduledArrivalTime: LocalDateModel;
  scheduledDepartureTime: LocalDateModel;
}

export class MultiStopUliOutputFormModel {
  uliInformation: MultiStopUliInformationOutputModel;
  truckInformation: UliTruckInformation;
  contactData: UliContactInformation;
  driverInformation: UliDriverInformation;

  constructor(params?: MultiStopUliOutputFormModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class MultiStopUliFormModel {
  uliInformation: MultiStopUliInformation;
  truckInformation: UliTruckInformation;
  contactData: UliContactInformation;
  driverInformation: UliDriverInformation;

  constructor(params?: MultiStopUliFormModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class MultiStopUliInformationForm {
  constructor(
    model: MultiStopUliInformation,
    fb: FormBuilder,
    public generateLoadNumber: ControlProperty<boolean> = model.generateLoadNumber,
    public loadNumber: ControlProperty<string> = model.loadNumber,
    public transportOrders: FormArray = fb.array([]),
  ) {
    model.transportOrders?.forEach((transportOrder: TransportOrderInformation) => {
      transportOrders.push(new TransportOrderInformationForm(transportOrder));
    });
  }
}

export class TransportOrderInformationForm {
  constructor(
    model: TransportOrderInformation,
    public transportOrderNumber: ControlProperty<string> = model.transportOrderNumber,
    public pickupPartyAddress: ControlProperty<AddressModel> = model.pickupPartyAddress,
    public deliveryPartyAddress: ControlProperty<AddressModel> = model.deliveryPartyAddress,
    public dangerousGoods: ControlProperty<boolean> = model.dangerousGoods,
    public customsGoods: ControlProperty<boolean> = model.customsGoods,
    public scheduledArrivalTime: ControlProperty<Date> = model.scheduledArrivalTime,
    public scheduledDepartureTime: ControlProperty<Date> = model.scheduledDepartureTime,
    public numberOfHandlingUnits: ControlProperty<number> = model.numberOfHandlingUnits,
    public weightGross: ControlProperty<number> = model.weightGross,
    public documentNumbers: ControlProperty<string[]> = model.documentNumbers,
    public type: ControlProperty<UliActivityType> = model.type,
    public loadingMeters: ControlProperty<number> = model.loadingMeters,
  ) {}
}
